/* eslint-disable max-lines-per-function */
import "./faq.scss";
import { sendDataLayer } from "jiffy-analytics";

const SELECTORS = {
  MENU_LINK: ".js-faq-menu-link",
  WRAPPER: ".js-faq-wrapper",
  LINK: ".js-faq-link",
  ANSWER: ".js-faq-answer",
  ICON: ".js-faq-icon",
  TITLE: ".js-faq-title"
};

const resetAnswers = wrappers => {
  wrappers.forEach(wrapper => {
    const answer = wrapper.querySelector(SELECTORS.ANSWER);
    const icons = wrapper.querySelectorAll(SELECTORS.ICON);

    if (answer.classList.contains("faq__questions-answer--hidden")) return;

    answer.classList.add("faq__questions-answer--hidden");
    icons.forEach(icon => icon.classList.toggle("hidden"));
  });
};

const showAnswer = wrapper => {
  const answer = wrapper.querySelector(SELECTORS.ANSWER);
  const icons = wrapper.querySelectorAll(SELECTORS.ICON);
  answer.classList.remove("faq__questions-answer--hidden");
  icons.forEach(icon => icon.classList.toggle("hidden"));
};

export default () => {
  const wrappers = document.querySelectorAll(SELECTORS.WRAPPER);
  const menuLink = document.querySelector(SELECTORS.MENU_LINK);
  if (!wrappers.length || !menuLink) return;

  if (window.location.hash) {
    const selectedAnchor = document.querySelector(
      `${SELECTORS.LINK}[href='${window.location.hash}']`
    );
    showAnswer(selectedAnchor.parentNode);
  }

  menuLink.addEventListener("click", e => {
    e.preventDefault();

    menuLink.parentNode.classList.toggle("faq__menu--open");
  });

  wrappers.forEach(wrapper => {
    const answer = wrapper.querySelector(SELECTORS.ANSWER);
    const link = wrapper.querySelector(SELECTORS.LINK);

    link.addEventListener("click", e => {
      e.preventDefault();
      const isHidden = answer.classList.contains("faq__questions-answer--hidden");

      resetAnswers(wrappers);
      if (isHidden) {
        showAnswer(wrapper);
        window.history.replaceState(null, "", link.hash);
        const label = link.querySelector(SELECTORS.TITLE);
        sendDataLayer({
          genericEvent: true,
          event: "click",
          eventCategory: "Page: FAQ",
          eventLabel: label.innerText
        });
      }
    });
  });
};
